export default {"src":"/_next/static/media/MOJITO.31306ced.svg","height":13,"width":58,"blurWidth":0,"blurHeight":0};